import createIcon from '../../createIcon';

/**
 * @component @name ThumbDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMkg2QzUuMTcgMiA0LjQ2IDIuNSA0LjE2IDMuMjJMMS4xNCAxMC4yN0MxLjA1IDEwLjUgMSAxMC43NCAxIDExVjEzQzEgMTQuMSAxLjkgMTUgMyAxNUg5LjMxTDguMzYgMTkuNTdMOC4zMyAxOS44OUM4LjMzIDIwLjMgOC41IDIwLjY4IDguNzcgMjAuOTVMOS44MyAyMkwxNi40MiAxNS40MUMxNi43OCAxNS4wNSAxNyAxNC41NSAxNyAxNFY0QzE3IDIuOSAxNi4xIDIgMTUgMlpNMTkgMlYxNEgyM1YySDE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThumbDown = createIcon('ThumbDown', [
  [
    'path',
    {
      d: 'M15 2H6C5.17 2 4.46 2.5 4.16 3.22L1.14 10.27C1.05 10.5 1 10.74 1 11V13C1 14.1 1.9 15 3 15H9.31L8.36 19.57L8.33 19.89C8.33 20.3 8.5 20.68 8.77 20.95L9.83 22L16.42 15.41C16.78 15.05 17 14.55 17 14V4C17 2.9 16.1 2 15 2ZM19 2V14H23V2H19Z',
      key: '1w8alz',
    },
  ],
]);

export default ThumbDown;
